import { request } from "./request";

export default class TemplatesAPI {
  /**
   * Duplicate page for multiple creators (service page or website)
   * @param {Object} data - Request data: { pageType: 'mango-page' | 'website', pageId: string, list: {email: string, host: string}[] }
   */
  static duplicateLandingPageForMultipleCreators(data) {
    const { pageType = "mango-page", pageId, list } = data;

    return request({
      url: "/admin/duplicate-landing-page-for-another-creator",
      method: "POST",
      data: {
        pageType,
        landingPageId: pageId,
        creators: list,
      },
    });
  }
}
